export const FORM_SELECT_STYLES = {
  control: (base) => ({
    ...base,
    borderColor: '#ced4da',
    boxShadow: 'none',
    fontSize: 14,
    height: 35,
    minHeight: 35,
    '&:hover': {
      borderColor: '#ced4da',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '2px 8px',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    marginLeft: 'auto',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 6,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 6,
  }),
  menu: (base) => ({
    ...base,
    border: '1px solid #dfe7ef',
    borderRadius: 8,
    boxShadow: '0 8px 18px rgba(33, 77, 122, 0.14)',
    overflow: 'hidden',
  }),
  option: (base) => ({
    ...base,
    fontSize: 14,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
}

export const NoIndicatorSeparator = () => null
